<div
  class="tw-inline-flex tw-items-center tw-justify-center tw-rounded-xl tw-px-3 tw-py-1 tw-font-medium tw-text-sm"
  [ngClass]="{
        'tw-bg-blue-100 tw-text-blue-800': value === 'published',
        'tw-bg-gray-100 tw-text-gray-600': value === 'draft'
      }"
>
  {{ label }}
</div>
